import { createSlice } from "@reduxjs/toolkit";
import { TeamMemberPaymentReducer } from "../../Reducers/Dashboard/TeamMemberPaymentReducer";
import type { TeamMemberPaymentsSummary } from "../../../Data/teamMemberPayment.dto";

export interface TeamMemberPaymentState {
  loading: boolean;
  payments: import("../../../Data/teamMemberPayment.dto").TeamMemberPayment[];
  team_member_payments: TeamMemberPaymentsSummary | null;
  count: number;
  total_pages: number;
  current_page: number;
  page_size: number;
  error: Record<string, unknown>;
}

const initialState: TeamMemberPaymentState = {
  loading: false,
  payments: [],
  team_member_payments: null,
  count: 0,
  total_pages: 0,
  current_page: 0,
  page_size: 15,
  error: {},
};

const teamMemberPaymentSlice = createSlice({
  name: "teamMemberPayment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    TeamMemberPaymentReducer(builder);
  },
});

export default teamMemberPaymentSlice.reducer;
